var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7V6.25C5.5 5.05653 5.97411 3.91193 6.81802 3.06802C7.66193 2.22411 8.80653 1.75 10 1.75C11.1935 1.75 12.3381 2.22411 13.182 3.06802C14.0259 3.91193 14.5 5.05653 14.5 6.25V7H16C16.1989 7 16.3897 7.07902 16.5303 7.21967C16.671 7.36032 16.75 7.55109 16.75 7.75V16.75C16.75 16.9489 16.671 17.1397 16.5303 17.2803C16.3897 17.421 16.1989 17.5 16 17.5H4C3.80109 17.5 3.61032 17.421 3.46967 17.2803C3.32902 17.1397 3.25 16.9489 3.25 16.75V7.75C3.25 7.55109 3.32902 7.36032 3.46967 7.21967C3.61032 7.07902 3.80109 7 4 7H5.5ZM15.25 8.5H4.75V16H15.25V8.5ZM9.25 12.799C8.96404 12.6339 8.74054 12.3791 8.61418 12.074C8.48782 11.7689 8.46565 11.4307 8.55111 11.1117C8.63657 10.7928 8.82489 10.5109 9.08686 10.3099C9.34882 10.1089 9.6698 9.99996 10 9.99996C10.3302 9.99996 10.6512 10.1089 10.9131 10.3099C11.1751 10.5109 11.3634 10.7928 11.4489 11.1117C11.5344 11.4307 11.5122 11.7689 11.3858 12.074C11.2595 12.3791 11.036 12.6339 10.75 12.799V14.5H9.25V12.799ZM7 7H13V6.25C13 5.45435 12.6839 4.69129 12.1213 4.12868C11.5587 3.56607 10.7956 3.25 10 3.25C9.20435 3.25 8.44129 3.56607 7.87868 4.12868C7.31607 4.69129 7 5.45435 7 6.25V7Z",
    fill: "#868C98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock2Line);
export default __webpack_public_path__ + "static/media/lock-2-line.055308459fbd6c06f1409fbef7824c73.svg";
export { ForwardRef as ReactComponent };